module.exports = "assets/cfbf5818197b3f04b5a85b82352f5ef1.glb";